/* eslint-disable max-lines */
/* eslint-disable complexity */
/* eslint-disable no-underscore-dangle */
// 9fbef606107a605d69c0edbcd8029e5d
/* eslint-disable sonarjs/no-identical-functions */
import {
  getAPIConfig,
  getBrand,
  getDateObject,
  getStringAcronym,
  isCanada,
} from '@tcp/core/src/utils';
import { getLocalStorage } from '@tcp/core/src/utils/localStorageManagement';
import { MAX_REC_ITEMS_PER_CAROUSEL } from '@tcp/core/src/components/common/molecules/Recommendations/container/Recommendations.constants';
import { readCookie, setCookie } from '../../../../utils/cookie.util';
import { getSiteId, getValueFromAsyncStorage } from '../../../../utils';
import { initiateApiCall, executeExternalAPICall } from '../../../handler';
import logger from '../../../../utils/loggerInstance';
import processResponse from '../../productListing/processResponse';
import endpoints from '../../../endpoints';
import monetateConstant from './constants';
import { getStoreRef } from '../../../../utils/store.utils';
import {
  getAiRecommendationsEnabled,
  isRecommendationFromMonetateEnabledWeb,
} from '../../../../reduxStore/selectors/session.selectors';
import { DIMENSION92_TEXT } from '../../../../utils/utils';

const {
  DECISION_REQUEST,
  USER_AGENT,
  PAGE_VIEW,
  CUSTOM_VARIABLES,
  CART_CONTEXT,
  PURCHASE,
  ADD_TO_CART,
  PRODUCT_DETAIL_VIEW,
  PRODUCT_THUMBNAIL_VIEW,
} = monetateConstant;

const attributeListMaker = (attributes) => {
  let finalData = {};
  if (attributes && Array.isArray(attributes)) {
    attributes.forEach((item) => {
      finalData = { ...finalData, ...item };
    });
    return finalData;
  }
  const finalArray =
    attributes &&
    attributes.split(`;`).map((attribute) => {
      const regexUrl = /((http|https):\/\/)?(([\w.-]*)\.([\w])).*/g;
      const isUrl = regexUrl.test(attribute);
      const match = attribute.match(regexUrl);
      const url = match && match[0].split('|');
      if (
        attribute.split(':')[0] === 'topRatedCategories' ||
        attribute.split(':')[0] === 'FeaturedCategories' ||
        attribute.split(':')[0] === 'variantDetails'
      ) {
        const attrAndValue = attribute.split(/:(.*)/s);
        return { [`${attrAndValue[0]}`]: `${attrAndValue[1]}` };
      }
      const attAndValue = attribute.split(`:`);
      return { [`${attAndValue[0]}`]: `${isUrl ? url : attAndValue[1]}` };
    });

  finalArray.forEach((item) => {
    finalData = { ...finalData, ...item };
  });
  return finalData;
};

const getImageUrl = (product) => {
  const value = product?.description
    ?.split(';')
    ?.filter((item) => item.split(':')?.[0] === 'ProductImage');
  const imageLink = value?.[0].split(':')?.[1];
  let imageUrl = product?.imageLink;
  const imageId = imageLink?.split('.')?.[0];
  const extension = imageLink?.split('.')?.[1];
  if (imageUrl?.split(imageId)?.[1] !== extension) {
    imageUrl = `${imageUrl?.split(imageId)?.[0]}${imageLink}`;
  }
  return imageUrl;
};

const RecommendationsAbstractor = {
  isUSStore: getSiteId() === 'us',
  formatResponseRecommendation: (event) => {
    let recs = '';
    let title = '';

    if (event.detail) {
      if (Array.isArray(event.detail)) {
        recs = event.detail;
      } else {
        recs = event.detail.recs || [];
        title = event.detail.title || '';
      }
    }

    return { recs, title };
  },
  // event listener callback that sets recommendations and clears itself
  getRecs: (resolve, xappURLConfig) => (event) => {
    const { recs, title } = RecommendationsAbstractor.formatResponseRecommendation(event);
    return resolve(RecommendationsAbstractor.parseProductResponse(recs, title, xappURLConfig));
  },
  getMcmId: () => {
    let mcmid;
    if (window._satellite && window._satellite.getVisitorId) {
      mcmid = window._satellite.getVisitorId().getMarketingCloudVisitorID();
    } else {
      const cookieArr = readCookie('AMCV_9A0A1C8B5329646E0A490D4D@AdobeOrg').split('|');
      mcmid = cookieArr.length ? cookieArr[cookieArr.indexOf('MCMID') + 1] : '';
    }

    return mcmid;
  },

  getMonetateRecAnalyticsIdentifier: (product) => {
    const { page = '', component = '' } = product || {};
    let pageName = page;
    if (page.indexOf('home') > -1) {
      pageName = 'homepage';
    }

    const recAcronym = getStringAcronym(component);
    const pageAcronym = getStringAcronym(pageName);
    let recAnalyticsIdentifier = `${DIMENSION92_TEXT}${recAcronym}`;
    if (recAcronym?.indexOf(pageAcronym) < 0) {
      recAnalyticsIdentifier = `${DIMENSION92_TEXT}${pageAcronym}`;
    }
    recAnalyticsIdentifier = recAnalyticsIdentifier.replace('homepage', 'hp');
    return recAnalyticsIdentifier;
  },

  getRecommendationObject: (recommendations, title = '', xappURLConfig, socialProofItems) => {
    return RecommendationsAbstractor.getProductsPrices(
      recommendations.map((recommendation) => recommendation.generalProductId),
      xappURLConfig
    ).then((prices) => {
      const allPrices = prices.reduce((productArr, price) => {
        return { ...productArr, ...price };
      }, {});

      return {
        products: recommendations.reduce((productsList, recommendation) => {
          if (typeof allPrices[recommendation.generalProductId] !== 'undefined') {
            productsList.push({
              ...recommendation,
              ...allPrices[recommendation.generalProductId],
            });
          }
          return productsList;
        }, []),
        mainTitle: title,
        socialProofItems,
      };
    });
  },
  getNoSearchRecomendationData: (
    { categoryFilterArray },
    title = '',
    xappURLConfig,
    socialProofItems = []
  ) => {
    return RecommendationsAbstractor.getProductsWithoutFilter(categoryFilterArray).then(
      (recommendations) => {
        return RecommendationsAbstractor.getProductsPrices(
          recommendations.map((recommendation) => recommendation?.uniqueId),
          xappURLConfig
        ).then((prices) => {
          const allPrices = prices.reduce((productArr, price) => {
            return { ...productArr, ...price };
          }, {});

          return {
            products: recommendations.reduce((productsList, recommendation) => {
              if (typeof allPrices[recommendation?.uniqueId] !== 'undefined') {
                productsList.push({
                  ...recommendation,
                  ...allPrices[recommendation.uniqueId],
                });
              }
              return productsList;
            }, []),
            mainTitle: title,
            socialProofItems,
          };
        });
      }
    );
  },
  /* eslint-disable camelcase */
  parseProductResponseForMonetateDirect: (products, xappURLConfig, socialProofItems) => {
    const recommendations = products.map((product) => {
      const {
        TCPBazaarVoiceRating = null,
        TCPBazaarVoiceReviewCount = null,
        TCPMerchantTagUSStore = '',
        TCPMerchantTagCanadaStore = '',
        TCPPrimaryBrandUSStore = '',
        TCPPrimaryBrandCanadaStore = '',
        TCPStyleTypeUS = '',
        TCPStyleQTYUS = '',
        TCPStyleTypeCA = '',
        TCPStyleQTYCA = '',
        promo_price = '',
        promo_id = '',
        is_hard_mark_enable: hardMarkDown = '',
      } = attributeListMaker(product?.description || '');
      // dummy-commit for qg
      const imageWithExtension = getImageUrl(product)?.split(`/`);
      const imagesPath = imageWithExtension?.[imageWithExtension.length - 1];
      const monRecsCarouselId =
        RecommendationsAbstractor.getMonetateRecAnalyticsIdentifier(product);
      return {
        generalProductId: product.itemGroupId?.replace(/_(US|CA)$/, ''),
        recToken: product.recToken,
        monRecsCarouselId,
        isRecentViewed: product.isRecentViewed,
        isRecentViewedUpdated: product.isRecentViewedUpdated,
        isSimilarItemtoConsider: product.isSimilarItemtoConsider,
        isPdpPlaProducts: product.isPdpPlaProducts,
        isFreeShippingQuickAdd: product.isFreeShippingQuickAdd,
        isAbPdpOos: product.isAbPdpOos,
        isPlpProducts: product.isPlpProducts,
        isAbCartCash: product.isAbCartCash,
        isAbCartReward: product.isAbCartReward,
        styleWithEligibility: product.isStyleWithDataAvailable,
        isFbt: product.isFbt,
        isOrderNotifications: product.isOrderNotifications,
        isNavLevel2Girls: product.isNavLevel2Girls,
        isNavLevel2Boys: product.isNavLevel2Boys,
        isNavLevel2ToddlerGirls: product.isNavLevel2ToddlerGirls,
        isNavLevel2ToddlerBoys: product.isNavLevel2ToddlerBoys,
        isNavLevel2Baby: product.isNavLevel2Baby,
        isInGridPlp: product.isInGridPlp,
        isPlpTrending: product.isPlpTrending,
        isOrderDetailProduct: product.isOrderDetailProduct,
        isInMultiGridPlp: product.isInMultiGridPlp,
        isTrendingInArea: product.isTrendingInArea,
        isSimilarProducts: product.isSimilarProducts,
        productInfo: {
          generalProductId: product?.itemGroupId,
          name: product?.title || '',
          pdpUrl: `/p${product?.link.split('/p')[1]}`,
          uniqueId: product?.itemGroupId || '',
          listPrice: product?.price || 0,
          offerPrice: product?.salePrice || 0,
          ratings: TCPBazaarVoiceRating,
          reviewsCount: TCPBazaarVoiceReviewCount,
          long_product_title: product?.title || '',
          TCPMerchantTagUSStore,
          TCPMerchantTagCanadaStore,
          primaryBrand: !isCanada() ? TCPPrimaryBrandUSStore : TCPPrimaryBrandCanadaStore,
          tcpStyleType: !isCanada() ? TCPStyleTypeUS : TCPStyleTypeCA,
          tcpStyleQty: !isCanada() ? TCPStyleQTYUS : TCPStyleQTYCA,
          hardMarkDown,
          TCPPromotionID: promo_id,
          TCPPromotionPrice: promo_price,
        },
        uniqueId: product?.itemGroupId,
        miscInfo: {
          isInDefaultWishlist: false,
        },
        imagesByColor: {
          SPRUCESHAD: {
            basicImageUrl: `${product?.itemGroupId.split('_')[0]}/${imagesPath}`,
            extraImages: [
              {
                isShortImage: false,
                isOnModalImage: false,
                iconSizeImageUrl: `${product?.itemGroupId.split('_')[0]}/${imagesPath}`,
                listingSizeImageUrl: `${product?.itemGroupId.split('_')[0]}/${imagesPath}`,
                regularSizeImageUrl: `${product?.itemGroupId.split('_')[0]}/${imagesPath}`,
                bigSizeImageUrl: `${product?.itemGroupId.split('_')[0]}/${imagesPath}`,
                superSizeImageUrl: `${product?.itemGroupId.split('_')[0]}/${imagesPath}`,
              },
            ],
          },
        },
        // app required params
        colorsMap: [
          {
            colorProductId: product?.itemGroupId,
            imageName: product?.itemGroupId,
            productImage: `${product?.itemGroupId}.jpg`,
            miscInfo: {
              bossDisabledFlags: {
                bossProductDisabled: 0,
                bossCategoryDisabled: 0,
              },
              listPrice: product?.price || 0,
              offerPrice: product?.salePrice || 0,
              isClearance: null,
              isBopisEligible: true,
              isBossEligible: true,
              badge1: {},
              badge2: null,
              badge3: (isCanada() ? TCPMerchantTagCanadaStore : TCPMerchantTagUSStore) || null,
              badge4: null,
              videoUrl: null,
              hasOnModelAltImages: false,
              keepAlive: false,
            },
            color: {
              name: null,
              imagePath: getImageUrl(product),
              swatchImage: `${product?.itemGroupId}_swatch.jpg`,
            },
          },
        ],
        accessoriesData: {},
        isFbtMulti: product?.isFbtMulti,
      };
    });
    return {
      products: recommendations,
      mainTitle: '',
      socialProofItems,
    };
  },

  parseProductResponseForMonetate: (products, xappURLConfig, socialProofItems) => {
    const recommendations = products.map((product) => ({
      generalProductId: product.itemGroupId?.replace(/_(US|CA)$/, ''),
      recToken: product.recToken,
      monRecsCarouselId: RecommendationsAbstractor.getMonetateRecAnalyticsIdentifier(product),
      pdpUrl: '',
      department: '',
      name: product.title,
      imagePath: getImageUrl(product),
      isFbtMulti: product.isFbtMulti,
      isRecentViewed: product.isRecentViewed,
      isSimilarItemtoConsider: product.isSimilarItemtoConsider,
      isPdpPlaProducts: product.isPdpPlaProducts,
      isFreeShippingQuickAdd: product.isFreeShippingQuickAdd,
      isAbPdpOos: product.isAbPdpOos,
      isPlpProducts: product.isPlpProducts,
      isAbCartCash: product.isAbCartCash,
      isAbCartReward: product.isAbCartReward,
      styleWithEligibility: product.isStyleWithDataAvailable,
      isFbt: product.isFbt,
      isOrderNotifications: product.isOrderNotifications,
      isNavLevel2Girls: product.isNavLevel2Girls,
      isNavLevel2Boys: product.isNavLevel2Boys,
      isNavLevel2ToddlerGirls: product.isNavLevel2ToddlerGirls,
      isNavLevel2ToddlerBoys: product.isNavLevel2ToddlerBoys,
      isNavLevel2Baby: product.isNavLevel2Baby,
      isInGridPlp: product.isInGridPlp,
      isPlpTrending: product.isPlpTrending,
      isOrderDetailProduct: product.isOrderDetailProduct,
      isInMultiGridPlp: product.isInMultiGridPlp,
      isTrendingInArea: product.isTrendingInArea,
      isSimilarProducts: product.isSimilarProducts,
    }));
    return RecommendationsAbstractor.getRecommendationObject(
      recommendations,
      '',
      xappURLConfig,
      socialProofItems
    );
  },

  parseProductResponse: (products, title, xappURLConfig) => {
    const recommendations = products
      .filter((product) => product.availability === 'In Stock')
      .map((product) => ({
        generalProductId: product.id.replace(/_(US|CA)$/, ''),
        pdpUrl: product.pdpURL,
        department: product.department,
        name: product.name,
        imagePath: product.imagePath,
      }));

    return RecommendationsAbstractor.getRecommendationObject(recommendations, title, xappURLConfig);
  },

  getData: (payload, xappURLConfig) => {
    const { MONETATE_ENABLED = true } = payload;
    const state = getStoreRef().getState();
    const isAiRecommendationEnabled = getAiRecommendationsEnabled(state);
    if (MONETATE_ENABLED && !isAiRecommendationEnabled)
      return RecommendationsAbstractor.getRecommendationsData(payload, xappURLConfig);
    return RecommendationsAbstractor.getAdobeData(payload, xappURLConfig);
  },

  getUnboxResultForNewArrivals: (selectedCategoryData) => {
    const { id } = selectedCategoryData;
    let webService = endpoints.getProductviewbyCategory;
    const requestBody = {
      start: 0,
      rows: 20,
      version: 'V2',
      'facet.multiselect': true,
      'variants.count': 0,
      selectedfacet: true,
      pagetype: 'boolean',
      sort: 'newest_score desc',
      fields:
        'productimage,alt_img,style_partno,swatchimage,TCPProductIndUSStore,TCPWebOnlyFlagUSStore,TCPWebOnlyFlagCanadaStore,TCPFitMessageUSSstore,TCPFit,product_name,TCPColor,imagename,productid,uniqueId,TCPBazaarVoiceReviewCount,categoryPath3_catMap,categoryPath2_catMap,product_short_description,style_long_description,min_list_price,min_offer_price,TCPBazaarVoiceRating,product_long_description,seo_token,variantCount,prodpartno,variants,v_tcpfit,v_qty,v_tcpsize,style_name,v_item_catentry_id,v_listprice,v_offerprice,v_qty,variantId,auxdescription,list_of_attributes,additional_styles,TCPLoyaltyPromotionTextUSStore,TCPLoyaltyPLCCPromotionTextUSStore,v_variant, low_offer_price, high_offer_price, low_list_price, high_list_price,long_product_title,TCPOutOfStockFlagUSStore,TCPOutOfStockFlagCanadaStore,TCPCustomSalePrice,TCPCustomListPrice,is_hard_mark_enable',
    };
    const parsedId = parseInt(id, 10);
    if (parsedId === 0) {
      webService = endpoints.getProductsBySearchTerm;
      requestBody.q = '*';
      delete requestBody['p-id'];
    } else {
      requestBody['p-id'] = `categoryPathId:"${id}"`;
    }
    return initiateApiCall({
      body: requestBody,
      webService,
    })
      .then((response) => {
        return processResponse(response, null, {
          getFacetSwatchImgPath: RecommendationsAbstractor.getFacetSwatchImgPath,
          getImgPath: RecommendationsAbstractor.getImgPath,
        });
      })
      .then((response) => {
        const products = response?.loadedProductsPages[0]?.map((product) => ({
          generalProductId: product?.productInfo?.generalProductId,
          pdpUrl: '',
          department: '',
          name: product?.productInfo?.name,
          imagePath: product?.colorsMap[0]?.color?.imagePath,
          ...product,
        }));

        return {
          products,
          mainTitle: '',
          socialProofItems: [],
        };
      });
  },

  getEmptyBannerRecomendationData: (payload, xappURLConfig) => {
    return RecommendationsAbstractor.getNoSearchRecomendationData(payload, xappURLConfig);
  },

  filterStyleWithdata: (actions, styleWithEligibility) => {
    let data = null;
    const styleWithData =
      actions.length && actions.filter((action) => action.component === 'mpackStyleWith');
    if (styleWithEligibility && styleWithData && styleWithData.length && styleWithData[0].items) {
      data = styleWithData[0].items.map((item) => ({ ...item, isStyleWithDataAvailable: true }));
    }
    return data;
  },

  getAdobeData: (
    {
      itemPartNumber,
      page,
      siteId = getSiteId(),
      categoryName,
      mboxName = 'global_recs_mbox',
      excludedIds,
      otherMboxProps,
    },
    xappURLConfig
  ) => {
    const mcmid = RecommendationsAbstractor.getMcmId();

    return new Promise((resolve, reject) => {
      if (window.adobe && window.adobe.target) {
        window.adobe.target.getOffer({
          mbox: mboxName,
          marketingCloudVisitorId: mcmid || '',
          params: {
            'entity.id': itemPartNumber ? `${itemPartNumber}_${siteId.toUpperCase()}` : '',
            'entity.categoryId': categoryName || '',
            pageType: page || '',
            site: (getBrand() || '').toUpperCase(),
            excludedIds,
            ...otherMboxProps,
          },
          success: (offer) => {
            const eventName = `res-${mboxName}`;
            const offers = offer;

            if (offers && offers.length > 0) {
              offers[0].content = offers[0].content.replace('pdpRecs', eventName);
              window.addEventListener(
                eventName,
                RecommendationsAbstractor.getRecs(resolve, xappURLConfig),
                {
                  once: true,
                }
              );
              window.adobe.target.applyOffer({
                mbox: mboxName,
                offer: offers,
              });
            } else {
              // eslint-disable-next-line sonarjs/no-duplicate-string
              reject(new Error('Empty recommendation'));
            }
          },
          error() {
            reject(new Error('Adobe getOffer Error'));
          },
        });
      }
    });
  },

  getCartLines: (cartItems) => {
    return cartItems.map((item) => ({
      sku: item.sku,
      pid: item.pid,
      quantity: item.quantity,
      currency: item.currency,
      value: String(item.value),
    }));
  },

  getProductIds: (cartItems) => {
    return cartItems.map((item) => `${item.pid}`);
  },

  updateItems: (items, response, recType) => {
    return items.concat(
      response.items.slice(0, MAX_REC_ITEMS_PER_CAROUSEL).map((item) => ({
        ...item,
        ...recType,
        action: response,
      }))
    );
  },

  getRecommendationsData: (
    {
      itemPartNumber,
      page,
      siteId = getSiteId(),
      categoryName,
      excludedIds,
      otherMboxProps,
      cartItems,
      outfitItems,
      skuData,
      styleWithEligibility,
      isPlcc,
      outOfStock,
      isLoggedIn,
      quickAdd,
      birthdayDepartment,
      primaryBrand,
      primaryCategory,
      categoryNameHp,
      isTabbedModule,
      productIds,
      recCarouselType,
    },
    xappURLConfig
  ) => {
    // eslint-disable-next-line sonarjs/cognitive-complexity
    return new Promise((resolve, reject) => {
      let productId = '';
      let extendedParams = {};
      if (skuData) {
        extendedParams = {
          style_qty: skuData.TCPStyleQTY ? skuData.TCPStyleQTY : '',
          style_type: skuData.TCPStyleType ? skuData.TCPStyleType : '',
          style_color: skuData.color && skuData.color.name ? skuData.color.name : '',
          product_family: skuData.productFamily ? skuData.productFamily : '',
        };
      }
      if (itemPartNumber) [productId] = itemPartNumber.split('&');
      let entityId = productId ? `${productId}_${siteId.toUpperCase()}` : '';
      if (skuData?.prodPartNo) {
        const prodPartNo = skuData?.prodPartNo;
        entityId = prodPartNo ? `${prodPartNo}_${siteId.toUpperCase()}` : '';
      }
      const customParams = {
        'entity.id': entityId,
        'entity.categoryId': categoryName || '',
        site: (getBrand() || '').toUpperCase(),
        apiRequestForMonetate: 'recommendation',
        productIds: productIds || [],
        isRegistered: isLoggedIn,
        hasPlcc: isPlcc || false, // Added false to send data in custom variables in case of undefined
        outOfStock: outOfStock || false,
        excludedIds,
        birthdayDepartment,
        primaryCategory: primaryCategory || '',
        ...extendedParams,
        ...otherMboxProps,
        brand: (primaryBrand || getBrand() || '').toLowerCase(),
      };
      if (page === 'cart' && (!Array.isArray(cartItems) || !cartItems.length)) {
        customParams.emptyCart = 'true';
      }
      if (page === 'order_details') {
        customParams.orderDetailsRecs = productIds;
      }
      if (page === 'cart' && quickAdd) {
        customParams.quickAdd = quickAdd.toString();
      }
      if (isTabbedModule && categoryNameHp) {
        customParams.categoryName = categoryNameHp?.toString();
      }
      const apiConfigObj = getAPIConfig();
      const { monetateUrl, monetateChannel } = apiConfigObj;
      const reqBody = {
        channel: monetateChannel,
        events: [
          {
            eventType: DECISION_REQUEST,
            // eslint-disable-next-line no-restricted-properties
            requestId: `${Math.round(Math.random() * Math.pow(10, 4))}`,
          },
          {
            eventType: USER_AGENT,
            userAgent: navigator.userAgent,
          },
          {
            eventType: PAGE_VIEW,
            url: window.location.href,
            pageType: page || '',
          },
          {
            eventType: CUSTOM_VARIABLES,
            customVariables: Object.keys(customParams).map((key) => ({
              variable: key,
              value: customParams[key],
            })),
          },
        ],
      };
      if (page === 'pdp' || page === 'added_to_bag') {
        reqBody.events.push({
          // eslint-disable-next-line sonarjs/no-duplicate-string
          eventType: 'monetate:context:ProductDetailView',
          products: [{ productId }],
        });
        reqBody.events.push({
          eventType: PRODUCT_THUMBNAIL_VIEW,
          products: RecommendationsAbstractor.getProductIds(cartItems),
        });
      } else if (page === 'cart' || page === 'checkout') {
        reqBody.events.push({
          eventType: CART_CONTEXT,
          cartLines: RecommendationsAbstractor.getCartLines(cartItems),
        });
        reqBody.events.push({
          eventType: PRODUCT_THUMBNAIL_VIEW,
          products: RecommendationsAbstractor.getProductIds(cartItems),
        });
      } else if (page === 'outfit') {
        reqBody.events.push({
          eventType: 'monetate:context:ProductDetailView',
          products: outfitItems,
        });
      }

      const monetateIdCookie = readCookie('mt.v');
      if (monetateIdCookie && monetateIdCookie !== 'null' && monetateIdCookie !== 'undefined')
        reqBody.monetateId = monetateIdCookie;
      const emailHash = getLocalStorage('email_hash');
      if (emailHash) reqBody.customerId = emailHash;
      executeExternalAPICall({
        webService: {
          method: 'POST',
          URI: monetateUrl,
        },
        body: reqBody,
      })
        .then((result) => {
          const { monetateId } = result.body.meta;
          if (typeof monetateId !== 'undefined')
            setCookie({
              key: 'mt.v',
              value: monetateId,
              daysAlive: 1,
            });

          const { responses } = result.body.data;
          if (!responses.length) return reject(new Error('Empty recommendation'));
          const { actions } = responses[0];
          if (!actions.length) return reject(new Error('Empty recommendation'));

          let items = [];
          let socialProofItems = [];
          const isStyleWithDataRecieved = RecommendationsAbstractor.filterStyleWithdata(
            actions,
            styleWithEligibility
          );

          if (isStyleWithDataRecieved) {
            items = isStyleWithDataRecieved;
          } else {
            actions.forEach((action) => {
              if (action.actionType === 'monetate:action:SocialProofData') {
                socialProofItems = socialProofItems.concat({ socialProofMessage: action });
              } else {
                const extraProps = {
                  component: action?.component || '',
                  page: page || '',
                };
                switch (action.component) {
                  case `${page}4`:
                    items = RecommendationsAbstractor.updateItems(items, action, {
                      isSimilarItemtoConsider: true,
                      ...extraProps,
                    });
                    break;
                  case `${page}3`:
                    items = RecommendationsAbstractor.updateItems(items, action, {
                      isFbtMulti: true,
                      ...extraProps,
                    });
                    break;
                  case `pdpRecentlyViewed`:
                    items = RecommendationsAbstractor.updateItems(items, action, {
                      isRecentViewedUpdated: true,
                      ...extraProps,
                    });
                    break;
                  case `${page}2`:
                    items = RecommendationsAbstractor.updateItems(items, action, {
                      isRecentViewed: true,
                      ...extraProps,
                    });
                    break;
                  case `${page}1`:
                    items = RecommendationsAbstractor.updateItems(items, action, {
                      isRecentViewed: false,
                      ...extraProps,
                    });
                    break;
                  case `${recCarouselType}`:
                    items = RecommendationsAbstractor.updateItems(items, action, {
                      isFreeShippingQuickAdd: true,
                      ...extraProps,
                    });
                    break;
                  case 'fbt':
                    items = RecommendationsAbstractor.updateItems(items, action, {
                      isFbt: true,
                      ...extraProps,
                    });
                    break;
                  case 'ab_pdp_oos':
                    items = RecommendationsAbstractor.updateItems(items, action, {
                      isAbPdpOos: true,
                      ...extraProps,
                    });
                    break;
                  case 'ab_pdp_pla':
                    items = RecommendationsAbstractor.updateItems(items, action, {
                      isPdpPlaProducts: true,
                      ...extraProps,
                    });
                    break;
                  case 'ab_plp_personalized':
                    items = RecommendationsAbstractor.updateItems(items, action, {
                      isPlpProducts: true,
                      ...extraProps,
                    });
                    break;
                  case 'ab_cart_cash':
                    items = RecommendationsAbstractor.updateItems(items, action, {
                      isAbCartCash: true,
                      ...extraProps,
                    });
                    break;
                  case 'ab_cart_reward':
                    items = RecommendationsAbstractor.updateItems(items, action, {
                      isAbCartReward: true,
                      ...extraProps,
                    });
                    break;
                  case 'in_grid_plp':
                    items = RecommendationsAbstractor.updateItems(items, action, {
                      isInGridPlp: true,
                      ...extraProps,
                    });
                    break;
                  case 'in_multi_grid_plp':
                    items = RecommendationsAbstractor.updateItems(items, action, {
                      isInMultiGridPlp: true,
                      ...extraProps,
                    });
                    break;
                  case 'plp_trending':
                    items = RecommendationsAbstractor.updateItems(items, action, {
                      isPlpTrending: true,
                      ...extraProps,
                    });
                    break;
                  case 'order_details':
                    items = RecommendationsAbstractor.updateItems(items, action, {
                      isOrderDetailProduct: true,
                      ...extraProps,
                    });
                    break;
                  case 'birthday1':
                    items = RecommendationsAbstractor.updateItems(items, action, {
                      isBirthDayModle: true,
                      ...extraProps,
                    });
                    break;
                  case 'trending_in_area':
                    items = RecommendationsAbstractor.updateItems(items, action, {
                      isTrendingInArea: true,
                      ...extraProps,
                    });
                    break;
                  default:
                    break;
                }
              }
            });
          }
          const state = getStoreRef()?.getState() || {};
          if (isRecommendationFromMonetateEnabledWeb(state) || isTabbedModule) {
            return resolve(
              RecommendationsAbstractor.parseProductResponseForMonetateDirect(
                items,
                xappURLConfig,
                socialProofItems
              )
            );
          }
          return resolve(
            RecommendationsAbstractor.parseProductResponseForMonetate(
              items,
              xappURLConfig,
              socialProofItems
            )
          );
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  sendEventsToMonetate: ({ recToken, isRecsClick }) => {
    const apiConfigObj = getAPIConfig();
    const { monetateUrl, monetateChannel } = apiConfigObj;
    const reqBody = {
      channel: monetateChannel,
      events: [
        isRecsClick
          ? {
              eventType: 'monetate:record:RecClicks',
              recClicks: [...recToken],
            }
          : {
              eventType: 'monetate:record:RecImpressions',
              recImpressions: [...recToken],
            },
      ],
    };

    const monetateIdCookie = readCookie('mt.v');
    if (monetateIdCookie && monetateIdCookie !== 'null' && monetateIdCookie !== 'undefined') {
      reqBody.monetateId = monetateIdCookie;
    }

    return executeExternalAPICall({
      webService: {
        method: 'POST',
        URI: monetateUrl,
      },
      body: reqBody,
    }).then(() => 'success');
  },

  sendAnalyticsEventsToMonetate: async ({
    eventId,
    isUserLoggedIn,
    categoryName,
    prodData,
    orderId,
  }) => {
    const apiConfigObj = getAPIConfig();
    const { monetateChannel, monetateUrl } = apiConfigObj;
    const customParams = {
      categoryId: categoryName || '',
      site: (getBrand() || '').toUpperCase(),
      isRegistered: isUserLoggedIn,
      brand: (getBrand() || '').toLowerCase(),
      date: getDateObject().toISOString().substring(0, 10),
    };
    const reqBody = {
      channel: monetateChannel,
      events: [
        {
          eventType: CUSTOM_VARIABLES,
          customVariables: Object.keys(customParams).map((key) => ({
            variable: key,
            value: customParams[key],
          })),
        },
      ],
    };
    if (eventId === 'addToCart') {
      reqBody.events.push({
        eventType: ADD_TO_CART,
        cartLines: [prodData],
      });
    }

    if (eventId === 'purchase') {
      reqBody.events.push({
        eventType: PURCHASE,
        domain: (getBrand() || '').toUpperCase(),
        purchaseId: orderId,
        purchaseLines: prodData,
      });
    }

    if (eventId === 'productView') {
      reqBody.events.push({
        eventType: PRODUCT_DETAIL_VIEW,
        products: [{ productId: prodData }],
      });
    }

    const monetateIdCookie = await getValueFromAsyncStorage('monetateId');
    if (monetateIdCookie && monetateIdCookie !== 'null' && monetateIdCookie !== 'undefined')
      reqBody.monetateId = monetateIdCookie;
    const emailHash = await getValueFromAsyncStorage('email_hash');
    if (emailHash) reqBody.customerId = emailHash;

    return executeExternalAPICall({
      webService: {
        method: 'POST',
        URI: monetateUrl,
      },
      body: reqBody,
    }).then(() => 'success');
  },

  getExtendedParams: (skuData) => {
    let extendedParams = {};
    if (skuData) {
      extendedParams = {
        style_qty: skuData.TCPStyleQTY ? skuData.TCPStyleQTY : '',
        style_type: skuData.TCPStyleType ? skuData.TCPStyleType : '',
        style_color: skuData.color && skuData.color.name ? skuData.color.name : '',
        product_family: skuData.productFamily ? skuData.productFamily : '',
      };
    }
    return extendedParams;
  },
  handleValidationError: (e) => {
    logger.error(e);
  },
  getOriginImgHostSetting: () => {
    return 'https://test4.childrensplace.com';
  },
  getSwatchImgPath: (id, excludeExtension) => {
    const imgHostDomain = RecommendationsAbstractor.getOriginImgHostSetting();
    return `${imgHostDomain}/wcsstore/GlobalSAS/images/tcp/products/swatches/${id}${
      excludeExtension ? '' : '.jpg'
    }`;
  },

  handleWhichRecommendationClicked: (portalValue) => {
    if (portalValue != null || portalValue !== '') {
      return portalValue;
    }
    return 'you-may-also-like-it';
  },

  getProductImgPath: (id, excludeExtension, imgExtension) => {
    const imageName = id?.split('_');
    const imagePath = imageName?.[0];
    return {
      125: `${imagePath}/${id}${excludeExtension ? '' : `.${imgExtension || 'jpg'}`}`,
      380: `${imagePath}/${id}${excludeExtension ? '' : `.${imgExtension || 'jpg'}`}`,
      500: `${imagePath}/${id}${excludeExtension ? '' : `.${imgExtension || 'jpg'}`}`,
      900: `${imagePath}/${id}${excludeExtension ? '' : `.${imgExtension || 'jpg'}`}`,
    };
  },

  getImgPath: (id, excludeExtension, imgExtension) => {
    return {
      colorSwatch: RecommendationsAbstractor.getSwatchImgPath(id, excludeExtension),
      productImages: RecommendationsAbstractor.getProductImgPath(
        id,
        excludeExtension,
        imgExtension,
        imgExtension
      ),
    };
  },
  getFacetSwatchImgPath: (id) => {
    const imgHostDomain = RecommendationsAbstractor.getOriginImgHostSetting();
    return `${imgHostDomain}/wcsstore/GlobalSAS/images/tcp/category/color-swatches/${id}.gif`;
  },
  /*
   * @function getProductsPrices
   * @summary Auxiliar method to retrieve prices for product recommendations. It returns prices for specific product ids
   * @param {Array[String]} productIds - the ids of all the products to get prices for
   */
  getProductsPrices: (items, xappURLConfig) => {
    const productsLength = Math.ceil(items.length / MAX_REC_ITEMS_PER_CAROUSEL);
    const recProductsPromise = [];
    [...Array(productsLength)].forEach((_, index) => {
      const productIds = items.slice(
        index * MAX_REC_ITEMS_PER_CAROUSEL,
        index * MAX_REC_ITEMS_PER_CAROUSEL + MAX_REC_ITEMS_PER_CAROUSEL
      );
      const payload = {
        body: {
          id: productIds.join(','),
          variants: true,
          'variants.count': 100,
          fields:
            'fields,TCPPromotions,productimage,alt_img,style_partno,swatchimage,TCPProductIndUSStore,TCPWebOnlyFlagUSStore,TCPWebOnlyFlagCanadaStore,TCPFitMessageUSSstore,TCPFit,product_name,TCPColor,imagename,productid,uniqueId,TCPBazaarVoiceReviewCount,categoryPath3_catMap,categoryPath2_catMap,product_short_description,style_long_description,min_list_price,min_offer_price,TCPBazaarVoiceRating,product_long_description,seo_token,variantCount,prodpartno,variants,v_tcpfit,v_qty,v_tcpsize,style_name,v_item_catentry_id,v_listprice,v_offerprice,v_qty,variantId,auxdescription,list_of_attributes,additional_styles,TCPLoyaltyPromotionTextUSStore,TCPLoyaltyPLCCPromotionTextUSStore,v_variant, low_offer_price, high_offer_price, low_list_price, high_list_price,long_product_title,TCPOutOfStockFlagUSStore,TCPOutOfStockFlagCanadaStore,TCPCustomSalePrice,TCPCustomListPrice',
        },
        webService: endpoints.getProductDetails,
      };
      const recProducts = initiateApiCall(payload, null, xappURLConfig)
        .then((res) => {
          return processResponse(res, null, {
            getFacetSwatchImgPath: RecommendationsAbstractor.getFacetSwatchImgPath,
            getImgPath: RecommendationsAbstractor.getImgPath,
            isRecommendationView: true,
          });
        })
        .then((res) => {
          const price = {};
          res.loadedProductsPages[0].forEach((product) => {
            price[product.productInfo.uniqueId] = {
              ...product,
            };
          });
          return price;
        })
        .catch((err) => {
          RecommendationsAbstractor.handleValidationError(err);
        });
      recProductsPromise.push(recProducts);
    });
    return Promise.all(recProductsPromise);
  },

  getProductsByFilter: async (productIds, filters = [], rows = 10, isHomepageCarousel) => {
    try {
      const filteredProducts = {};
      const requestPayload = {
        body: {
          q: '*',
          filter: filters,
          rows,
          fields:
            'categoryPath2,productimage,alt_img,style_partno,giftcard,TCPProductIndUSStore,TCPWebOnlyFlagUSStore,TCPWebOnlyFlagCanadaStore,TCPFitMessageUSSstore,TCPFit,product_name,TCPColor,top_rated,imagename,productid,uniqueId,favoritedcount,TCPBazaarVoiceReviewCount,categoryPath3_catMap,categoryPath2_catMap,product_short_description,style_long_description,min_list_price,min_offer_price,TCPBazaarVoiceRating,product_long_description,seo_token,variantCount,prodpartno,variants,v_tcpfit,v_qty,v_tcpsize,style_name,v_item_catentry_id,v_listprice,v_offerprice,v_qty,variantId,auxdescription,list_of_attributes,additional_styles,TCPLoyaltyPromotionTextUSStore,TCPLoyaltyPLCCPromotionTextUSStore,v_variant,low_offer_price,high_offer_price,low_list_price,high_list_price,long_product_title,TCPOutOfStockFlagUSStore,TCPOutOfStockFlagCanadaStore,TCPMerchantTagUSStore,TCPCustomSalePrice,TCPCustomListPrice',
        },
        webService: endpoints.getProductInfoById,
      };
      const unbxdResponse = await initiateApiCall(requestPayload);
      if (isHomepageCarousel) {
        return unbxdResponse?.body?.response?.products;
      }
      const processedResponse = await processResponse(unbxdResponse, null, {
        getFacetSwatchImgPath: RecommendationsAbstractor.getFacetSwatchImgPath,
        getImgPath: RecommendationsAbstractor.getImgPath,
        isRecommendationView: true,
      });
      processedResponse.loadedProductsPages[0].forEach((product) => {
        filteredProducts[product.productInfo.uniqueId] = {
          ...product,
        };
      });
      return filteredProducts;
    } catch (error) {
      RecommendationsAbstractor.handleValidationError(error);
    }
    return {};
  },
  getProductsWithoutFilter: async (categoryId, rows = 10) => {
    try {
      const requestPayload = {
        body: {
          variants: true,
          'variants.count': 0,
          version: 'V2',
          'facet.multiselect': true,
          selectedfacet: true,
          rows,
          'p-id': `categoryPathId:"${categoryId}"`,
          pagetype: 'boolean',
          fieldsVal:
            'TCPPromotions,related_product_swatch_images,productimage,alt_img,style_partno,giftcard,swatchimage,TCPProductIndUSStore,TCPFitMessageUSSstore,TCPFit,TCPWebOnlyFlagUSStore,TCPWebOnlyFlagCanadaStore,TCPSwatchesUSStore,top_rated,TCPSwatchesCanadaStore,product_name,TCPColor,imagename,productid,uniqueId,favoritedcount,TCPBazaarVoiceReviewCount,categoryPath3_fq,categoryPath3,categoryPath3_catMap,categoryPath2_catMap,product_short_description,min_list_price,min_offer_price,TCPBazaarVoiceRating,seo_token,prodpartno,banner,facets,auxdescription,list_of_attributes,numberOfProducts,redirect,searchMetaData,didYouMean,TCPLoyaltyPromotionTextUSStore,TCPLoyaltyPLCCPromotionTextUSStore,TcpBossCategoryDisabled,TcpBossProductDisabled,long_product_title,TCPOutOfStockFlagUSStore,TCPOutOfStockFlagCanadaStore,product_type,products,low_offer_price, high_offer_price, low_list_price, high_list_price,TCPStyleTypeUS,TCPStyleTypeCA,TCPStyleQTYCA,TCPStyleQTYUS,TCPProductIndCanadaStore,TCPCustomSalePrice,TCPCustomListPrice',
        },
        webService: endpoints.getProductviewbyCategory,
      };
      const unbxdResponse = await initiateApiCall(requestPayload);
      return unbxdResponse?.body?.response?.products;
    } catch (error) {
      RecommendationsAbstractor.handleValidationError(error);
    }
    return {};
  },

  getPriority: (proofType) => {
    switch (proofType) {
      case 'purchase':
        return 3;
      case 'view':
        return 2;
      case 'cart':
        return 1;
      default:
        return 0;
    }
  },

  extractSocialProofData: (dataArray) => {
    const result = {};
    dataArray.forEach((item) => {
      const socialProofData = Array.isArray(item?.socialProofMessage?.data)
        ? item?.socialProofMessage?.data
        : [];

      socialProofData.forEach((proofData) => {
        const productId = proofData?.productId || '';
        const count = proofData?.count || 0;
        const component = item?.socialProofMessage?.component || '';
        const proofType = proofData?.proofType || '';

        // Extract the part after the underscore ('_') in the component
        const underscoreIndex = component?.indexOf('_');
        const componentPart =
          underscoreIndex !== -1 ? component?.substring(underscoreIndex + 1) : '';

        const modifiedComponent = componentPart?.replace('#', count);

        if (!result[productId]) {
          result[productId] = { productId, count, component: modifiedComponent, proofType };
        } else {
          const existingEntry = result[productId];
          const existingPriority = RecommendationsAbstractor.getPriority(existingEntry?.proofType);
          const newPriority = RecommendationsAbstractor.getPriority(proofType);

          // Compare priorities and update the result with the entry having higher priority
          if (newPriority > existingPriority) {
            result[productId] = {
              productId,
              count,
              component: modifiedComponent,
              proofType,
            };
          }
        }
      });
    });

    return Object.values(result);
  },

  getSocialProofMsg: (socialProofItems = {}) => {
    let priorityMsg = '';
    let purchaseTypePresent = false;
    let viewTypePresent = false;
    let variation = '';
    Object.keys(socialProofItems).forEach((item) => {
      const messageOriginal = socialProofItems?.[item]?.socialProofMessage?.component;
      const proofOfType = socialProofItems?.[item]?.socialProofMessage?.data?.proofType;
      const count = socialProofItems?.[item]?.socialProofMessage?.data?.count;
      let message = messageOriginal?.replace('#', count);
      message = message?.split('_').pop();
      if (proofOfType?.includes('purchase')) {
        priorityMsg = message;
        variation = messageOriginal?.toLowerCase()?.includes('bottom') ? 'bottom' : 'top';
        purchaseTypePresent = true;
      } else if (proofOfType?.includes('view') && !purchaseTypePresent) {
        priorityMsg = message;
        viewTypePresent = true;
        if (messageOriginal?.toLowerCase()?.includes('top')) {
          variation = 'top';
        }
        if (messageOriginal?.toLowerCase()?.includes('bottom')) {
          variation = 'bottom';
        }
      } else if (proofOfType?.includes('cart') && !purchaseTypePresent && !viewTypePresent) {
        variation = messageOriginal?.toLowerCase()?.includes('bottom') ? 'bottom' : 'top';
        priorityMsg = message;
      }
    });
    return { priorityMsg, variation };
  },
};
export default RecommendationsAbstractor;
